<template>
  <div>
    <the-nav-bar/>

    <v-fade-transition mode="out-in">
      <router-view/>
    </v-fade-transition>
  </div>
</template>

<script>
import VFadeTransition from '@/components/transitions/VFadeTransition'
import TheNavBar from '@/components/common/TheNavBar'

import { mapMutations } from 'vuex'

export default {
  components: { VFadeTransition, TheNavBar },
  mounted() {
    const user = localStorage.getItem('user-object');
    if (user) {
      this.setUser(JSON.parse(user));
    }
  },
  methods: {
    ...mapMutations("auth", ["setUser"])
  }
}
</script>